import { render, staticRenderFns } from "./ReviewAndComment.vue?vue&type=template&id=812f3992&scoped=true&"
import script from "./ReviewAndComment.vue?vue&type=script&lang=js&"
export * from "./ReviewAndComment.vue?vue&type=script&lang=js&"
import style0 from "./ReviewAndComment.vue?vue&type=style&index=0&id=812f3992&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "812f3992",
  null
  
)

export default component.exports